// External libraries
import styled from '@emotion/styled';

// Internal modules
import { PRIMARY_COLOR } from '@/styles';

const HeaderContainer = styled.div`
  margin-bottom: ${props => (props.isBasl ? '0' : '16px')};
`;

// Using a pseudo element for the background-image because it needs to
// be 100vw, not just 100% of the header
const StyledHeader = styled.header`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 15px 0;

  &::before {
    background-image: linear-gradient(to bottom, #f5f7fa, #fefeff 86%, #fff);
    content: '';
    display: block;
    height: 54px;
    left: 0;
    position: absolute;
    top: 0;
    width: 100vw;
  }
`;

/**
 * Necessary because IE 11 hates justify-content (and democracy)
 * If we just use `justify-content: space-between` on the <Header /> then
 * the logo will be right aligned. Using `flex-grow` to make the logo
 * container take up all empty space in the header which will result in
 * it extending to the left side of the header.
 */
const LogoContainer = styled.div`
  flex-grow: 1;
  z-index: 1;
`;

const LogInButton = styled.button`
  background-color: transparent;
  border: 1px solid ${PRIMARY_COLOR};
  border-radius: 15px;
  color: ${PRIMARY_COLOR};
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  min-width: 96px;
  padding: 6px 10px;
  z-index: 1;

  &:focus,
  &:hover {
    background-color: ${PRIMARY_COLOR};
    color: #fff;
    text-decoration: underline;
  }
`;

const CartButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid transparent;
  color: #2c2e2f;
  cursor: ${props => (props.shouldLoadCartDropdown ? 'pointer' : 'default')};
  display: flex;
  font-size: 15px;
  font-weight: 700;
  outline: 0;
  padding: 0;
  position: relative;
`;

const CartAmount = styled.span`
  margin-left: 6px;
  padding-top: 2px;
  text-align: right;
`;

export {
  CartAmount,
  CartButton,
  HeaderContainer,
  LogInButton,
  LogoContainer,
  StyledHeader,
};
